<template>
  <div id="app">
    <Nav></Nav>
    <router-view/>
    <Footer/>
    <Moble />
  </div>
</template>
<script>
  import Nav from '@/components/Nav'
  import Footer from '@/components/Footer'
  import Moble from '@/components/Moble'
  export default {
    components:{
      Nav,Footer,Moble
    }
  }
</script>
<style lang="less">
  @import url('./assets/animate.css');
  body{
    font-family: '微软雅黑';
    overflow-x: hidden;
    li,ul{
      padding: 0;
      margin: 0;
      list-style: none;
    }
  }
  @media only screen and (max-width: 786px){
      #app{
          padding-bottom: 70px;
      }
  }
  .sacleBig{
    transition: all 0.2s;
    &:hover{
      transform: scale(1.1);
    }
  }
</style>
